import axiosInstance from '../axiosConfig';

const API_URL = '/api/mail-settings';

export type MailSettingsType = 'SYSTEM' | 'NORMAL' | 'GOOGLE' | 'MICROSOFT';

/**
 * Mirrors the backend {@code MailSettingsDto}.
 *
 * Read fields: type, host, port, tls, from, username, clientId, tenantId,
 *              passwordSet, clientSecretSet, refreshTokenSet
 *
 * Write-only fields (null = keep existing, '' = clear):
 *              password, clientSecret
 */
export interface MailSettingsDto {
    type?: MailSettingsType;
    host?: string;
    port?: number;
    tls?: boolean;
    from?: string;
    username?: string;
    clientId?: string;
    tenantId?: string;

    // Write-only secrets (never populated in GET responses)
    password?: string;
    clientSecret?: string;

    // Read-only presence indicators
    passwordSet?: boolean;
    clientSecretSet?: boolean;
    refreshTokenSet?: boolean;
}

export const MailSettingsService = {
    async getSettings(): Promise<MailSettingsDto> {
        const response = await axiosInstance.get<MailSettingsDto>(API_URL);
        return response.data;
    },

    async saveSettings(dto: MailSettingsDto): Promise<MailSettingsDto> {
        const response = await axiosInstance.put<MailSettingsDto>(API_URL, dto);
        return response.data;
    },

    /**
     * Returns the authorization URL for the given OAuth2 provider.
     * Open this URL in the browser so the user can grant consent.
     */
    async getAuthorizationUrl(provider: 'google' | 'microsoft'): Promise<string> {
        const response = await axiosInstance.get<string>(
            `${API_URL}/${provider}/authorize`,
            { headers: { Accept: 'text/plain' } }
        );
        return response.data;
    },

    async sendTestEmail(to: string): Promise<void> {
        await axiosInstance.post(`${API_URL}/test`, null, { params: { to } });
    },
};
